import { handleActions } from 'redux-actions'
import { fromJS } from 'immutable'

import { NAME } from './constants'

export const initialState = fromJS({
  // States for `account`:
  // - false: Unknown if logged in or not yet.
  // - null/undefined: Not logged in.
  // - object: Logged in.
  account: false,
  // This key is updated when logging out and used to re-mount the entire
  // contents of the `<App>` component, causing all React state to be reset.
  // It’s important to only update when logging out, not in, to avoid
  // re-mounting on startup (the app is rendered with no user (`account ===
  // false` until the login requests are done)). The re-mount causes double
  // network requests, annoying flashes and can break redux-form.
  accountKey: Date.now(),
  djediNodes: {},
})

export default handleActions(
  {
    [NAME]: {
      SET: (state, { payload }) => state.merge(fromJS(payload)),
      ADD_DJEDI_NODES: (state, { payload }) => state.set('djediNodes', payload),
    },
  },
  initialState,
)



// WEBPACK FOOTER //
// ../source/views/App/reducer.js